import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppRoutes } from "../shared/app/routers/appRouters";

// Component pages

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./master-tables/master-tables.module").then(
        (m) => m.MasterTablesModule
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./clients/clients.module").then((m) => m.ClientsModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./slips/slips.module").then((m) => m.SlipsModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./business-development/business-development.module").then(
        (m) => m.BusinessDevelopmentModule
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./customer-service/customer-service.module").then(
        (m) => m.CustomerServiceModule
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./production/production.module").then((m) => m.ProductionModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./it-department/it-department.module").then((m) => m.ItDepartmentModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./claims/claims.module").then((m) => m.ClaimsModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./finance/finance.module").then((m) => m.FinanceModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./staff-panel/staff-panel.module").then(
        (m) => m.StaffPanelModule
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./system-admin/system-admin.module").then(
        (m) => m.SystemAdminModule
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./email/email.module").then((m) => m.EmailModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./activities/activities.module").then((m) => m.ActivitiesModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./notification/notification.module").then(
        (m) => m.NotificationModule
      ),
  },
  {
    path: AppRoutes.Notification.dispatch,
    loadComponent: () =>
      import(
        "../shared/components/dispatch-document/dispatch-list/dispatch-list.component"
      ).then((c) => c.DispatchListComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
